'use client';

import dynamic from 'next/dynamic';

export const EasingComparisonDemo = dynamic(
  () => import('./EasingComparisonDemo')
);

export const LinearDemo = dynamic(
  () => import('./LinearDemo/LinearDemo')
);

export const SpringVisualizerDemo = dynamic(
  () => import('./SpringVisualizerDemo/SpringVisualizerDemo')
);

export const LinearVsRealSpringsDemo = dynamic(
  () => import('./LinearVsRealSpringsDemo/LinearVsRealSpringsDemo')
);
